import type { SVGProps } from "react";
const SvgMortarboard02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 8c0 1.342 8.106 5 10 5s10-3.658 10-5-8.106-5-10-5S2 6.658 2 8"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6 11 .245 5.63c.005.113.018.226.05.334.101.333.288.637.572.84 2.225 1.595 8.041 1.595 10.266 0 .284-.203.47-.507.572-.84.032-.108.045-.221.05-.334L18 11"
    />
    <path
      fill="currentColor"
      d="M21.25 9.5a.75.75 0 0 0-1.5 0h1.5m-2.179 10.263.73.174zm2.858 0 .73-.173zM20.5 9.5h-.75v7.007h1.5V9.5zm-1.429 10.263.73.174c.145-.61.394-1.167.66-1.69.245-.477.565-1.03.737-1.464l-.698-.276-.698-.275c-.136.346-.366.726-.676 1.333-.288.564-.599 1.244-.784 2.025zm2.858 0 .73-.173c-.186-.78-.497-1.461-.785-2.025-.31-.607-.54-.987-.676-1.333l-.698.275-.698.276c.172.433.492.987.736 1.465.267.522.516 1.079.66 1.689zM20.815 21v-.75h-.63v1.5h.63zm-1.744-1.237-.73-.173c-.123.52-.197 1.206.293 1.697.229.23.511.338.76.393.248.055.52.07.79.07v-1.5c-.228 0-.374-.014-.465-.035-.091-.02-.07-.033-.023.013.057.058.058.112.055.081a1.3 1.3 0 0 1 .05-.372zm2.858 0-.73.174c.05.213.054.326.05.372-.003.03-.002-.023.055-.081.046-.046.068-.033-.023-.013s-.237.035-.466.035v1.5c.271 0 .543-.015.791-.07.249-.055.531-.163.76-.393.49-.49.416-1.178.292-1.697z"
    />
  </svg>
);
export default SvgMortarboard02;
